import { getFacilityTagListAsync, replaceFacilityTagsAsync } from "src/api/building/commonfacility-api";
import { BuildingFacilityTagParams } from "src/api/building/commonfacility-types";
import { useApiOperation } from "src/api/hooks";
import { useErrorModal } from "src/recoil/errorModal/hook";
import { useModal } from "src/recoil/modalState/hook";

const useFacilityTag = () => {
  const { openErrorModal } = useErrorModal();
  const { setBaseModal } = useModal();
  const { executeAsync: getFacilityTags } = useApiOperation(getFacilityTagListAsync);

  const { executeAsync: replaceFacilityTags } = useApiOperation(replaceFacilityTagsAsync);

  // 태그 목록 조회
  const getFacilityTagList = async (searchParams?: BuildingFacilityTagParams) => {
    const response = await getFacilityTags(searchParams).catch(() => undefined);
    return response?.data.data.content ?? [];
  };

  // 태그 치환
  const onUpdateFacilityTags = async (facilityId?: string, tagIds?: string[]) => {
    await replaceFacilityTags({ facilityId: facilityId || "", tagIds: tagIds || [] });
    return true;
  };

  const handleTagError = async (errorMeta: any) => {
    const { errorCode, status, cause } = errorMeta;
    if (errorCode === "ePR0516") {
      setBaseModal({
        isOpen: true,
        title: "이미 등록된 태그입니다.",
        children: (
          <p>
            동일한 태그명이 존재하여 추가할 수 없습니다.
            <br />
            다른 이름을 입력하거나 기존 태그를 수정해주세요.
          </p>
        ),
        btnRightTitle: "확인",
        onClick: () => setBaseModal({ isOpen: false }),
      });
    } else {
      openErrorModal({ errorCode, statusCode: status, cause });
    }
  };

  return { handleTagError, getFacilityTagList, onUpdateFacilityTags };
};

export default useFacilityTag;
